import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row, Input } from "reactstrap";
import { Fn_DisplayData, Fn_FillListData, Fn_AddEditData, convertToArray } from "../../store/Functions";  // Import Fn_AddEditData
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import ReactToggle from "react-toggle";

function AddEdit_SalesMaster() {
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/Region`;
  const API_URL_SAVE = "SalesMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/SalesMasterEdit/Id`;

  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fill list data
        await Fn_FillListData(dispatch, setState, "FillArray", `${API_URL}/Id/0`);
        
        // Get the ID from location.state
        const Id = (location.state && location.state.Id) || 0;
        
        if (Id > 0) {
          // Update state with the ID
          setState(prevState => ({
            ...prevState,
            id: Id,
          }));
          
          // Fetch and display data
          const response = await Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
          
          // Check if response.dataList exists and has data
          if (response.dataList && response.dataList.length > 0) {
            let obj = response.dataList[0];
            
            // Process regions (convert to array if needed)
            let regions = obj.Regions;
            regions = convertToArray(regions);
            
            // Assign processed regions to formData
            obj.F_RegionMaster = regions;
            console.log(obj)
            // Set formData in state
            setState(prevState => ({
              ...prevState,
              formData: obj,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, [dispatch, location.state]);
  



  // Validation Schema
  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    F_RegionMaster: Yup.array().min(1, "At least one region must be selected").required("Region is required"),
    Password: Yup.string().required("Password is required"),
    MobileNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
      .required("Mobile number is required"),
  });

  const handleSubmit = async values => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    console.log(values);
    let formData = new FormData();
    formData.append("Name", values.Name);
    formData.append("Regions",(values.F_RegionMaster).join(','));  // Store selected region IDs as JSON
    formData.append("Password", values.Password);
    formData.append("F_CompanyMaster", 2);
    formData.append("MobileNo", values.MobileNo);
    formData.append("IsActive", values.IsActive);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
        navigate,
      "/salesmaster"
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          IsActive: state.formData.IsActive || false,
          F_RegionMaster: state.formData.F_RegionMaster || [],
          MobileNo: state.formData.MobileNo || "",
          Password: state.formData.Password || "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={values => handleSubmit(values)}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            {/* Name Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Name" className="form-label">Name</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="Name" placeholder="ex: Shyam Sharma"/>
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Mobile Number Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="MobileNo" className="form-label">Mobile No</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="MobileNo" placeholder="Enter 10-digit Mobile Number"/>
                <ErrorMessage name="MobileNo" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Password Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Password" className="form-label">Password</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="password" name="Password" placeholder="Enter Password"/>
                <ErrorMessage name="Password" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Region Selection */}
            <Row>
              <Col lg="2">
                <label htmlFor="F_RegionMaster" className="form-label">Region</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Input
                  type="select"
                  name="F_RegionMaster"
                  multiple
                  onChange={e => {
                    const selectedValues = Array.from(e.target.selectedOptions, option => option.value);
               
                    setFieldValue("F_RegionMaster", selectedValues);
                  }}
                >
                  {state.FillArray.map(type => (
                    <option key={type.Id} value={type.Id}  selected={values.F_RegionMaster && values.F_RegionMaster.includes(type.Id.toString())}>{type.Name}</option>
                  ))}
                </Input>
                <ErrorMessage name="F_RegionMaster" component="div" className="text-danger" />
              </Col>
              <Col><strong>{state.formData.RegionNames && state.formData.RegionNames}</strong></Col>
            </Row>

            {/* Active Toggle */}
            <Row>
              <Col lg="1" className="mb-3">
                <label htmlFor="IsActive" className="form-label">Active</label>
              </Col>
              <Col lg="2">
                <ReactToggle
                  checked={values.IsActive}
                  onChange={() => setFieldValue("IsActive", !values.IsActive)}
                />
                <ErrorMessage name="IsActive" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_SalesMaster;
